import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { fetchJobs, fetchReportJobs } from "../../../services/httpClient";
import SelectObject from "../../ui/SelectObject";
import DataTable from "../ui/DataTable";
import { loadingCard } from "../../../helpers/loading";

interface JobsTableProps {
  data?: any[];
  deptList?: any[];
  showHeader?: boolean;
}

export const JobsTable = ({ data, deptList, showHeader = false }: JobsTableProps) => {
  const [assignments, setAssignments] = useState<any[]>();
  const [filteredAssignments, setFilteredAssignments] = useState<any>([]);
  const [selectedDepartment, setSelectedDepartment] = useState<number>();
  const [departments, setDepartments] = useState<any[]>([]);

  const tableHeaders = [
    { label: "Department ID", key: "id", hide: true },
    { label: "Department", key: "department" },
    { label: "Job ID", key: "job_id", hide: true },
    { label: "Job", key: "job" },
    { label: "Case", key: "case_name" },
    { label: "Name", key: "name" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      if (data && deptList) {
        setAssignments(data);
        setFilteredAssignments(data);
        setDepartments(deptList);
      } else {
        await getJobData();
      }
    };

    fetchData();
  }, [data, deptList]);

  const getJobData = async () => {
    fetchReportJobs()
      .then((res: any) => {
        const reportJobs = res[0].data;
        setAssignments(reportJobs);
        setFilteredAssignments(reportJobs);
        const deptCounts = reportJobs.reduce((acc: Record<string, number>, job: any) => {
          const dept = job.department;
          acc[dept] = (acc[dept] || 0) + 1;
          return acc;
        }, {});

        fetchJobs()
          .then((res: any) => {
            const jobs = res[0].data;
            const deptMap = new Map<string, any>();
            jobs.forEach((j: any) => {
              const deptName = j.department;
              const count = deptCounts[deptName] ?? 0;
              if (!deptMap.has(deptName)) {
                deptMap.set(deptName, { name: `${deptName} (${count})`, key: deptName, count });
              }
            });

            Object.entries(deptCounts).forEach(([dept, count]) => {
              const key = dept;
              if (!deptMap.has(key)) {
                deptMap.set(key, { name: `${key} (${count})`, key, count });
              } else {
                const existing = deptMap.get(key);
                existing.count = count;
                existing.name = `${key} (${count})`;
              }
            });

            const departments = Array.from(deptMap.values()).sort((a: any, b: any) => a.key.localeCompare(b.key));
            setDepartments(departments);
          })
          .catch((err: any) => {
            console.log(err);
          });
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const updateJob = (e: any) => {
    setSelectedDepartment(e.target.value);
    const filtered = assignments?.filter((d: any) => {
      if (e.target.value === "0") {
        return d;
      } else {
        return d.department === e.target.value;
      }
    });
    console.log(filtered);
    setFilteredAssignments(filtered);
  };

  return (
    <>
      {assignments ? (
        <>
          {showHeader && (
            <Row>
              <Col>
                <h5 className="app-header-text">Current Job Assignments</h5>
              </Col>
            </Row>
          )}
          {assignments?.length > 0 && (
            <>
              <Row id="jobs-filters">
                <Col xs={4} className="mb-1">
                  <SelectObject
                    label="Department (# People)"
                    initialOption="View All"
                    value={selectedDepartment}
                    options={departments}
                    onUpdate={(e: any) => updateJob(e)}
                  />
                </Col>
              </Row>
              <DataTable tableHeadings={tableHeaders} tableData={filteredAssignments} title="jobs" hideTitle={true} hideDownload={true} />
            </>
          )}
        </>
      ) : (
        loadingCard()
      )}
    </>
  );
};
